import { PrimaryButton, ButtonSize } from '@uni-of-exeter/digital.lib.react.ui.kit';
import { getBookmarksPath } from '../../../routes/paths';
import { useRouter } from '../../../routes/hooks';
import '../styles/resource-bookmark-toast.css';
import { APP_TEXT } from '../../../const/app-text';
import { useBookmarkToastMessage } from '../../../hooks/custom/bookmarking/use-bookmark-toast';

type ResourceBookmarkToastText = {
  resourceTitle: string;
  messageText: string;
};

export interface ResourceBookmarkToastProps {
  resourceId: string;
  isBookmarked: boolean;
  text: ResourceBookmarkToastText;
  toastMessageId: string;
}

export const ResourceBookmarkToast = ({
  text,
  isBookmarked,
  resourceId,
  toastMessageId,
}: ResourceBookmarkToastProps): JSX.Element => {
  const router = useRouter();
  const { handleUndoClick } = useBookmarkToastMessage();

  const messageTextClassName = isBookmarked ? 'messageTextShort' : 'messageTextFullSize';
  const toastText = APP_TEXT.components.toast.bookmarking;

  return (
    <div className={`bookmarkedResourceToastWrapper`}>
      <div className={`messageText ${messageTextClassName}`}>
        <b>{text.resourceTitle}</b> {text.messageText}
      </div>

      {!!isBookmarked && (
        <PrimaryButton
          buttonSize={ButtonSize.Small}
          className="viewBookmarksBtn"
          label={toastText.viewBookmarksBtnText}
          severity="success"
          aria-label={toastText.accessibility.viewBookmarksBtnLabel}
          onClick={() => {
            router.push(getBookmarksPath());
          }}
        />
      )}

      <PrimaryButton
        buttonSize={ButtonSize.Small}
        className={`undoBookmarkBtn`}
        label={toastText.undoBookmarkActionBtnText}
        severity="success"
        aria-label={toastText.accessibility.undoBookmarkActionBtnLabel}
        onClick={(event) => {
          event.preventDefault();
          handleUndoClick({
            isBookmarked,
            resourceId,
            toastMessageId,
          });
        }}
      />
    </div>
  );
};
